import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type ReplaceHistory = ReturnType<typeof useHistory>['replace'];

export const useStatedHistory = () => {
  const history = useHistory();
  const { state, key } = useLocation();

  const replace: ReplaceHistory = useCallback(
    (location, s) => {
      const nextState = {
        ...(state as any),
      };

      if (!key) {
        nextState.__clearBack = true;
      }

      history.replace(location, {
        ...nextState,
        ...(s as any),
      });
    },
    [history, state, key],
  );

  return {
    ...history,
    replace,
  };
};
